import { useNavigate } from "react-router-dom";
import { comics } from "@/mocks/comics";
import ComicCard from "@/components/feature/ComicCard";
import SectionTitle from "@/components/feature/SectionTitle";

export default function LatestSection() {
  const navigate = useNavigate();
  const latest = [...comics]
    .sort((a, b) => (a.isNew === b.isNew ? 0 : a.isNew ? -1 : 1))
    .slice(0, 8);

  return (
    <section className="w-full py-14 md:py-16">
      <div className="container-x">
        <SectionTitle
          kicker="今日新番"
          title="最新更新，抢先看"
          desc="古风漫画网热门作品每日更新，第一时间汇总当天上新的漫画与章节。"
          action={
            <button
              onClick={() => navigate("/category")}
              className="inline-flex items-center gap-1 whitespace-nowrap rounded-md border border-foreground-300 px-4 py-2 text-sm font-semibold text-foreground-800 transition-colors hover:border-primary-500 hover:text-primary-600 cursor-pointer"
            >
              查看全部<i className="ri-arrow-right-line text-xs"></i>
            </button>
          }
        />
        <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 md:gap-5 lg:grid-cols-4">
          {latest.map((comic) => (
            <ComicCard key={comic.id} comic={comic} />
          ))}
        </div>
      </div>
    </section>
  );
}